import { createRouter, createWebHistory } from 'vue-router';
import store from '../store/index';
import {config} from '@/config/setting';
import {helper} from "@/helper";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('../pages/HomePage.vue'),
        meta: { title: '首页' },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../pages/LoginPage.vue'),
        meta: { title: '登录' },
    },
    // 全局 404 路由
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import('../pages/404Page.vue'),
        meta: { title: '404' },
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () => import('../pages/admin/IndexPage.vue'),
        meta: { title: 'Main' },
        children:[
            {
                path: '/admin/console',
                name: 'Console',
                component: () => import('../pages/admin/ConsolePage.vue'),
                meta: { title: '控制台' },
            },
            {
                path: '',
                name: 'AdminDefault',
                component: () => import('../pages/assembly/BlankAssembly.vue'),
                meta: { title: '空白页' },
            },
            {
                path: '/admin/material/type',
                name: 'AdminMaterialType',
                component: () => import('../pages/admin/material/type/ListPage'),
                meta: { title: '物料类型' },
            },
            {
                //物料列表
                path: '/admin/material/list',
                name: 'AdminMaterialList',
                component: () => import('../pages/admin/material/table/ListPage'),
                meta: { title: '物料列表' },
            },
            {
              //库位管理
                path: '/admin/stock/list',
                name: 'AdminLocationList',
                component: () => import('../pages/admin/stock/location/ListPage'),
                meta: { title: '库位管理' },
            },
            {
                //清单管理  出库 入库 移库 记录物料入库详情 只关注库存 不统计价值 操作库存
                path: '/admin/stockTable/list',
                name: 'AdminStockList',
                component: () => import('../pages/admin/stock/table/ListPage'),
                meta: { title: '清单管理' },
            },
            {
                //库存盘点 物料在库情况信息 包含物料信息及对应货道
                path: '/admin/stockCheck/list',
                name: 'AdminStockCheck',
                component: () => import(
                    '../pages/admin/stock/check/ListPage'
                    )
                ,
                meta: { title: '盘点管理' },
            },
            {
                //计量单位
                path: '/admin/unit/list',
                name: 'AdminUnitList',
                component: () => import('../pages/admin/unit/ListPage'),
                meta: { title: '计量单位' },
            },
            {
                //物料规格
                path: '/admin/spec/list',
                name: 'AdminSpecList',
                component: () => import('../pages/admin/spec/ListPage'),
                meta: { title: '规格管理' },
            },
            {
                //供应商管理
                path: '/admin/supplier/list',
                name: 'AdminSupplierList',
                component: () => import('../pages/admin/supplier/ListPage'),
                meta: { title: '供应商管理' },
            },
            {
                //品牌管理
                path: '/admin/brand/list',
                name: 'AdminBrandList',
                component: () => import('../pages/admin/brand/ListPage'),
                meta: { title: '品牌管理' },
            },
            {
                //客户管理
                path: '/admin/customer/list',
                name: 'AdminCustomerList',
                component: () => import('../pages/admin/customer/ListPage'),
                meta: { title: '客户管理' },
            },
            {
                //型号管理
                path: '/admin/model/list',
                name: 'AdminModelList',
                component: () => import('../pages/admin/model/ListPage'),
                meta: { title: '型号管理' },
            },
            {
                //订单列表  销售 采购 计算收益 成本 税  操作库存 记录价值
                path: '/admin/order/list',
                name: 'AdminOrderList',
                component: () => import('../pages/admin/order/ListPage'),
                meta: { title: '订单列表' },
            },
            {
                //账单统计
                path: '/admin/bill/list',
                name: 'AdminBillList',
                component: () => import('../pages/admin/bill/ListPage'),
                meta: { title: '财务统计' },
            },
            {
                //权限管理
                path: '/admin/role/list',
                name: 'AdminRoleList',
                component: () => import('../pages/admin/role/ListPage'),
                meta: { title: '权限管理' },
            },
            {
                //账号列表
                path: '/admin/user/list',
                name: 'AdminUserList',
                component: () => import('../pages/admin/user/ListPage'),
                meta: { title: '账号列表' },
            },
            {
                //领料单
                path: '/admin/picking/list',
                name: 'AdminPickingList',
                component: () => import('../pages/admin/picking/ListPage'),
                meta: { title: '员工领料单' },
            },
            {
                //消息列表
                path: '/admin/message/list',
                name: 'AdminMessageList',
                component: () => import('../pages/admin/message/ListPage'),
                meta: { title: '消息列表' },
            },
            {
                //通知人管理
                path: '/admin/message/people',
                name: 'AdminMessagePeople',
                component: () => import('../pages/admin/message/PeoplePage'),
                meta: { title: '通知人管理' },
            },
        ]
    }
];

const router = createRouter({
    mode: 'history', // 去掉url中的#
    history: createWebHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = `${to.meta.title} - ${config.baseTitle}`;
        store.commit('setTitle', `${to.meta.title} - ${config.baseTitle}`);
        store.commit('setUserInfo', helper.getUserInfo());
        store.commit('setPageName', to.meta.title);
    }
    next();
});

export default router;

